export default "__VITE_PUBLIC_ASSET__158b2e0e__"